import './CorporateBurn.css'
import CorporateBurnCard from './CorporateBurnCard'
import corporate1 from '../assets/image/corporate1.jpg'
import corporate2 from '../assets/image/corporate2.jpg'


const burnCardData = [
    {
        id: 1,
        image: corporate2,
        title: 'Before',
        description: 'Stressed and uncooperative team',
    },
    {
        id: 2,
        image: corporate1,
        title: 'After',
        description: 'Motivated and engaged Team',
    },
];


export default function CorporateBurn() {
    return (
        <>
            <div className='corporate-burn-section'>
                <div className="container">
                    <div className="corporate-burn-warpper">
                        <div className='corporate-burn-text-wrapper'>
                            <h1>Corporate Burnout is Real. So Is the Disengagement.</h1>
                            <p>Stressed teams don’t collaborate. Disconnected teams don’t stay. The biggest cost? Quiet quitting and lost productivity.</p>
                        </div>
                        <div className='corporate-burn-content-section'>
                            {burnCardData.map((item) => (
                                <CorporateBurnCard
                                    key={item.id}
                                    image={item.image}
                                    title={item.title}
                                    description={item.description}
                                />
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
